import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { ModuleWithProviders, NgModule, Provider } from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';

import { MapsService } from './maps.service';
import { MapsComponent } from './maps/maps.component';

export abstract class MapSettingsLoader {
  abstract mapsKey: string;
}

export type MapPlace = google.maps.places.PlaceResult;

export type MapMarker = {
  id: string;
  lat: number;
  lng: number;
};

@NgModule({
  declarations: [MapsComponent],
  exports: [MapsComponent],
  imports: [CommonModule, GoogleMapsModule],
  providers: [provideHttpClient(withInterceptorsFromDi(), withJsonpSupport())],
})
export class MapsModule {
  static forRoot(settings: Provider): ModuleWithProviders<MapsModule> {
    return {
      ngModule: MapsModule,
      providers: [settings, MapsService],
    };
  }
}
